const $ = window.jQuery;

export function init() {
    // Initialize the global ironman object if it doesn't exist (but it really should be there already)
    if (!window.ironman) {
        window.ironman = {};
    }

    // Init Waldo
    if($('body').hasClass('waldo-map')) {
        window.ironman.waldo = 'map';
    } else if ($('body').hasClass('waldo-planner')) {
        window.ironman.waldo = 'planner';
    } else if ($('body').hasClass('waldo-planner-create')) {
        window.ironman.waldo = 'planner-create';
    } else if ($('body').hasClass('waldo-place')) {
        window.ironman.waldo = 'place';
    } else if ($('body').hasClass('waldo-camino')) {
        window.ironman.waldo = 'camino';
    } else if ($('body').hasClass('waldo-listing')) {
        window.ironman.waldo = 'listing';
    } else if ($('body').hasClass('waldo-credential')) {
        window.ironman.waldo = 'credential';
    } else if ($('body').hasClass('waldo-edit-post')) {
        window.ironman.waldo = 'edit-post';
    } else if ($('body').hasClass('waldo-manage')) {
        window.ironman.waldo = 'manage';
    } else if ($('body').hasClass('waldo-favorites')) {
        window.ironman.waldo = 'favorites';
    } else if ($('body').hasClass('waldo-directory-home')) {
        window.ironman.waldo = 'directory-home';
    }

}
